import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import { useNavigate } from "react-router-dom";
import FCLogo from "../../Assets/Images/fucascore_png.png";

const FSAdminAddTurnir = () => {
  const navigate = useNavigate();
  const [turniri, setTurniri] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTurnir, setEditingTurnir] = useState(null);

  const [turnirLogo, setTurnirLogo] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const [formData, setFormData] = useState({
    naziv: "",
    slug: "",
    series_slug: "",
    datum_od: "",
    datum_do: "",
    whitelist_email: "",
    logo_url: "",
    broj_igraca: 5,
    kotizacija: "",
    show_turnir: true,
    countdown_enabled: false,
    countdown_time: "00:00",
    total_fund: "",
    first_place: "",
    second_place: "",
    third_place: "",
    best_player: "",
    best_scorer: "",
    best_gk: "",
    first_place_veterani: "",
    second_place_veterani: "",
    third_place_veterani: "",
    features: {
      beli: false,
      kosarka: false,
      nogotenis: false,
      veterani: false,
    },
  });

  useEffect(() => {
    fetchTurniri();
  }, []);

  const toggleShowTurnir = async (turnir) => {
    const newStatus = !turnir.show_turnir;
    const { error } = await supabase
      .from("admin_turniri")
      .update({ show_turnir: newStatus })
      .eq("id", turnir.id);

    if (error) {
      alert("Greška pri promjeni vidljivosti: " + error.message);
    } else {
      fetchTurniri();
    }
  };

  const fetchTurniri = async () => {
    const { data } = await supabase
      .from("admin_turniri")
      .select("*")
      .order("created_at", { ascending: false });
    if (data) setTurniri(data);
  };

  const handleNazivChange = (e) => {
    const nazivVal = e.target.value;
    const generatedSlug = nazivVal
      .toLowerCase()
      .trim()
      .replace(/[čć]/g, "c")
      .replace(/š/g, "s")
      .replace(/ž/g, "z")
      .replace(/đ/g, "d")
      .replace(/\s+/g, "-");

    setFormData({
      ...formData,
      naziv: nazivVal,
      slug: generatedSlug,
      series_slug: formData.series_slug || generatedSlug,
    });
  };

  const compressImage = (file, maxWidth = 300, maxHeight = 300) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const compressedFile = new File([blob], `${Date.now()}.webp`, {
                  type: "image/webp",
                });
                resolve(compressedFile);
              } else {
                reject(new Error("Kompresija nije uspjela."));
              }
            },
            "image/webp",
            0.8,
          );
        };
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const uploadLogo = async (file) => {
    const compressedFile = await compressImage(file);
    const fileName = `${Math.random()}-${Date.now()}.webp`;
    const filePath = `turnir-logos/${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from("logo-turniri")
      .upload(filePath, compressedFile);

    if (uploadError) throw uploadError;
    const { data } = supabase.storage
      .from("logo-turniri")
      .getPublicUrl(filePath);
    return data.publicUrl;
  };

  const handleSave = async () => {
    if (!formData.naziv) return alert("Naziv je obavezan!");

    setIsUploading(true);
    try {
      let finalLogoUrl = formData.logo_url;

      if (turnirLogo && typeof turnirLogo !== "string") {
        finalLogoUrl = await uploadLogo(turnirLogo);
      }

      let isoTargetDate = null;
      if (formData.countdown_enabled && formData.datum_od) {
        const timeVal = formData.countdown_time || "00:00";
        isoTargetDate = new Date(
          `${formData.datum_od}T${timeVal}`,
        ).toISOString();
      }

      const payload = {
        naziv: formData.naziv,
        slug: formData.slug,
        series_slug: formData.series_slug
          ? formData.series_slug.trim().toLowerCase()
          : null,
        datum_od: formData.datum_od,
        datum_do: formData.datum_do,
        whitelist_email: formData.whitelist_email
          ? formData.whitelist_email.trim().toLowerCase()
          : null,
        logo_url: finalLogoUrl,
        broj_igraca: parseInt(formData.broj_igraca, 10),
        kotizacija: formData.kotizacija
          ? formData.kotizacija.toString().trim()
          : null,
        show_turnir: formData.show_turnir,
        countdown_enabled: formData.countdown_enabled,
        countdown_target: isoTargetDate,
        total_fund: formData.total_fund,
        first_place: formData.first_place,
        second_place: formData.second_place,
        third_place: formData.third_place,
        best_player: formData.best_player,
        best_scorer: formData.best_scorer,
        best_gk: formData.best_gk,
        first_place_veterani: formData.features.veterani
          ? formData.first_place_veterani
          : null,
        second_place_veterani: formData.features.veterani
          ? formData.second_place_veterani
          : null,
        third_place_veterani: formData.features.veterani
          ? formData.third_place_veterani
          : null,
        features: formData.features,
      };

      let res;
      if (editingTurnir) {
        res = await supabase
          .from("admin_turniri")
          .update(payload)
          .eq("id", editingTurnir.id);
      } else {
        res = await supabase.from("admin_turniri").insert([payload]);
      }
      if (res.error) throw res.error;

      if (formData.whitelist_email && formData.whitelist_email.trim() !== "") {
        await supabase
          .from("invited_organizers")
          .upsert([{ email: formData.whitelist_email.trim() }], {
            onConflict: "email",
            ignoreDuplicates: true,
          });
      }

      setIsModalOpen(false);
      setEditingTurnir(null);
      setTurnirLogo(null);
      setFormData({
        naziv: "",
        slug: "",
        series_slug: "",
        datum_od: "",
        datum_do: "",
        whitelist_email: "",
        logo_url: "",
        countdown_time: "00:00",
        total_fund: "",
        first_place: "",
        second_place: "",
        third_place: "",
        best_player: "",
        best_scorer: "",
        best_gk: "",
        first_place_veterani: "",
        second_place_veterani: "",
        third_place_veterani: "",
        features: {
          beli: false,
          kosarka: false,
          nogotenis: false,
          veterani: false,
        },
      });
      fetchTurniri();
    } catch (err) {
      alert("Greška: " + err.message);
    } finally {
      setIsUploading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("hr-HR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="fs-admin-add-turnir">
      <nav className="admin-navbar">
        <a href="/fucascore-admin">
          <img src={FCLogo} alt="FucaScore logo" className="logo" />
        </a>
        <div className="title">FucaScore Teo</div>
        <button
          className="logout-btn"
          onClick={async () => {
            await supabase.auth.signOut();
            navigate("/admin-login");
          }}
        >
          Odjava
        </button>
      </nav>
      <div className="header-row">
        <button
          className="back-btn"
          onClick={() => navigate("/fucascore-admin")}
        >
          <i className="fi fi-rs-angle-left"></i> Nazad
        </button>
      </div>

      <div className="add-turnir-section">
        <h2>Dodaj turnir</h2>
        <div
          className="add-action-box"
          onClick={() => {
            setEditingTurnir(null);
            setTurnirLogo(null);
            setFormData({
              naziv: "",
              slug: "",
              series_slug: "",
              datum_od: "",
              datum_do: "",
              whitelist_email: "",
              logo_url: "",
              features: {
                beli: false,
                kosarka: false,
                nogotenis: false,
                veterani: false,
              },
            });
            setIsModalOpen(true);
          }}
        >
          <div className="circle-plus">+</div>
          <span>Kreiraj novi turnir</span>
        </div>
      </div>

      <div className="turniri-list">
        {turniri.map((t) => (
          <div key={t.id} className="turnir-card">
            <div className="card-info">
              <div className="card-info-top">
                {t.logo_url && (
                  <img
                    className="turnir-logo"
                    src={t.logo_url}
                    alt="Logo turnira"
                  />
                )}
                <h3>{t.naziv}</h3>
              </div>
              <p className="subdomain-text">/{t.slug}</p>
              <p style={{ fontSize: "0.75rem" }}>
                {formatDate(t.datum_od)} – {formatDate(t.datum_do)}
              </p>
              {t.whitelist_email && (
                <p
                  className="email-text"
                  style={{ fontSize: "0.85rem", color: "#888" }}
                >
                  <i className="fi fi-rs-envelope"></i> {t.whitelist_email}
                </p>
              )}
            </div>
            <div className="buttons">
              <button
                className={`visibility-btn ${t.show_turnir ? "is-visible" : "is-hidden"}`}
                onClick={() => toggleShowTurnir(t)}
              >
                {t.show_turnir ? "Sakrij" : "Prikaži"}
              </button>

              <button
                className="edit-btn"
                onClick={() => {
                  setEditingTurnir(t);
                  setTurnirLogo(t.logo_url || null);
                  setFormData({
                    ...t,
                    whitelist_email: t.whitelist_email || "",
                    slug: t.slug || "",
                    series_slug: t.series_slug || "",
                    datum_od: t.datum_od || "",
                    datum_do: t.datum_do || "",
                    logo_url: t.logo_url || "",
                    show_turnir: t.show_turnir ?? true,
                    features:
                      typeof t.features === "string"
                        ? JSON.parse(t.features)
                        : t.features || {
                            beli: false,
                            kosarka: false,
                            nogotenis: false,
                            veterani: false,
                          },
                  });
                  setIsModalOpen(true);
                }}
              >
                Uredi
              </button>
            </div>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div
          className="modal-overlay"
          onClick={(e) =>
            e.target.className === "modal-overlay" && setIsModalOpen(false)
          }
        >
          <div className="fs-modal">
            <h2>{editingTurnir ? "Uredi Turnir" : "Novi Turnir"}</h2>

            <div className="modal-form-stack">
              <input
                placeholder="Naziv turnira"
                value={formData.naziv}
                onChange={handleNazivChange}
              />

              <input
                placeholder="Link turnira"
                value={formData.slug}
                onChange={(e) =>
                  setFormData({ ...formData, slug: e.target.value })
                }
              />

              <input
                placeholder="Serija turnira"
                value={formData.series_slug}
                onChange={(e) =>
                  setFormData({ ...formData, series_slug: e.target.value })
                }
              />

              {/* DATUM OD - DO */}
              <input
                type="date"
                value={formData.datum_od}
                onChange={(e) =>
                  setFormData({ ...formData, datum_od: e.target.value })
                }
              />
              <input
                type="date"
                value={formData.datum_do}
                onChange={(e) =>
                  setFormData({ ...formData, datum_do: e.target.value })
                }
              />

              {/* ODBROJAVANJE S TOGGLE GUMBOM */}
              <div className="countdown-section">
                <label
                  className={`toggle-switch ${formData.countdown_enabled ? "on" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={formData.countdown_enabled}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        countdown_enabled: e.target.checked,
                      })
                    }
                  />
                  <span className="slider"></span>
                  <span className="label-text">
                    Aktiviraj odbrojavanje do početka
                  </span>
                </label>

                {formData.countdown_enabled && (
                  <div className="countdown-time-wrapper">
                    <label className="time-label">
                      Vrijeme početka (Sat i minuta):
                    </label>
                    <input
                      type="time"
                      value={formData.countdown_time}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          countdown_time: e.target.value,
                        })
                      }
                    />
                  </div>
                )}
              </div>

              <input
                placeholder="Email organizatora"
                value={formData.whitelist_email}
                onChange={(e) =>
                  setFormData({ ...formData, whitelist_email: e.target.value })
                }
              />

              <div className="form-group select-group">
                <label>Format igrača (na terenu)</label>
                <select
                  value={formData.broj_igraca}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      broj_igraca: parseInt(e.target.value, 10),
                    })
                  }
                >
                  <option value={3}>2+1</option>
                  <option value={4}>3+1</option>
                  <option value={5}>4+1</option>
                  <option value={6}>5+1</option>
                  <option value={7}>6+1</option>
                  <option value={8}>7+1</option>
                </select>
              </div>

              <input
                placeholder="Kotizacija (npr. 150 €)"
                value={formData.kotizacija}
                onChange={(e) =>
                  setFormData({ ...formData, kotizacija: e.target.value })
                }
              />

              {/* GLAVNE NAGRADE */}
              <div className="prizes-section">
                <h4>Nagradni fond i nagrade</h4>
                <input
                  placeholder="Ukupni fond (€)"
                  value={formData.total_fund}
                  onChange={(e) =>
                    setFormData({ ...formData, total_fund: e.target.value })
                  }
                />
                <div className="prizes-grid">
                  <input
                    placeholder="1. mjesto"
                    value={formData.first_place}
                    onChange={(e) =>
                      setFormData({ ...formData, first_place: e.target.value })
                    }
                  />
                  <input
                    placeholder="2. mjesto"
                    value={formData.second_place}
                    onChange={(e) =>
                      setFormData({ ...formData, second_place: e.target.value })
                    }
                  />
                  <input
                    placeholder="3. mjesto"
                    value={formData.third_place}
                    onChange={(e) =>
                      setFormData({ ...formData, third_place: e.target.value })
                    }
                  />
                </div>
                <input
                  placeholder="Najbolji igrač"
                  value={formData.best_player}
                  onChange={(e) =>
                    setFormData({ ...formData, best_player: e.target.value })
                  }
                />
                <input
                  placeholder="Najbolji strijelac"
                  value={formData.best_scorer}
                  onChange={(e) =>
                    setFormData({ ...formData, best_scorer: e.target.value })
                  }
                />
                <input
                  placeholder="Najbolji golman"
                  value={formData.best_gk}
                  onChange={(e) =>
                    setFormData({ ...formData, best_gk: e.target.value })
                  }
                />
              </div>

              {/* NAGRADE VETERANA S TOGGLE GUMBOM GORE (BEZ NAJBOLJEG IGRAČA, STRIJELCA I GOLMANA) */}
              <div className="veterans-prizes-section">
                <label
                  className={`toggle-switch ${formData.features.veterani ? "on" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={formData.features.veterani}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        features: {
                          ...formData.features,
                          veterani: e.target.checked,
                        },
                      })
                    }
                  />
                  <span className="slider"></span>
                  <span className="label-text">Nagrade (Veterani)</span>
                </label>

                {formData.features.veterani && (
                  <div
                    className="veterans-inputs-wrapper"
                    style={{
                      marginTop: "12px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <div className="prizes-grid">
                      <input
                        placeholder="Vet. 1. mjesto"
                        value={formData.first_place_veterani}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            first_place_veterani: e.target.value,
                          })
                        }
                      />
                      <input
                        placeholder="Vet. 2. mjesto"
                        value={formData.second_place_veterani}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            second_place_veterani: e.target.value,
                          })
                        }
                      />
                      <input
                        placeholder="Vet. 3. mjesto"
                        value={formData.third_place_veterani}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            third_place_veterani: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* VIDLJIVOST */}
              <div className="form-group checkbox-group">
                <label
                  className={`toggle-switch checkbox-style ${formData.show_turnir ? "on" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={Boolean(formData.show_turnir)}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        show_turnir: e.target.checked,
                      })
                    }
                  />
                  <span className="slider"></span>
                  <span className="label-text">
                    Prikaži turnir na javnoj stranici
                  </span>
                </label>
              </div>

              {/* LOGO UPLOAD */}
              <div className="form-group">
                <label className="section-title-label">Logo turnira</label>
                <label
                  htmlFor="turnir-logo-upload"
                  className="custom-file-upload"
                >
                  {turnirLogo ? (
                    <div className="logo-preview-badge">
                      {typeof turnirLogo === "string" ? (
                        <img src={turnirLogo} alt="Logo" />
                      ) : (
                        <i
                          className="fi fi-rs-check-circle"
                          style={{ color: "#2ecc71" }}
                        ></i>
                      )}
                      <span>
                        {typeof turnirLogo === "string"
                          ? "Promijeni logo"
                          : "Nova slika odabrana"}
                      </span>
                    </div>
                  ) : (
                    <>
                      <i className="fi fi-rs-plus-small"></i> Dodaj logo turnira
                    </>
                  )}
                </label>
                <input
                  id="turnir-logo-upload"
                  type="file"
                  accept="image/*"
                  onChange={(e) => setTurnirLogo(e.target.files[0])}
                  style={{ display: "none" }}
                />
              </div>

              {/* OSTALE FEATURES OPCIJE (Beli, Košarka, Nogotenis) */}
              <div className="features-container">
                <p>Omogući ostale opcije:</p>
                <div className="toggle-group">
                  {Object.keys(formData.features)
                    .filter((feat) => feat !== "veterani")
                    .map((feat) => {
                      const labels = {
                        beli: "Bela",
                        kosarka: "Košarka",
                        nogotenis: "Nogotenis",
                      };

                      return (
                        <label
                          key={feat}
                          className={`toggle-switch ${formData.features[feat] ? "on" : ""}`}
                        >
                          <input
                            type="checkbox"
                            checked={formData.features[feat]}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                features: {
                                  ...formData.features,
                                  [feat]: e.target.checked,
                                },
                              })
                            }
                          />
                          <span className="slider"></span>
                          <span className="label-text">{labels[feat]}</span>
                        </label>
                      );
                    })}
                </div>
              </div>
              {/* INSTAGRAM COPY SECTION */}
              <div
                className="instagram-copy-section"
                style={{
                  marginTop: "20px",
                  borderTop: "1px solid rgba(255,255,255,0.1)",
                  paddingTop: "15px",
                }}
              >
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    fontSize: "0.9rem",
                  }}
                >
                  Instagram tekst za objavu:
                </label>
                <textarea
                  readOnly
                  value={(() => {
                    const cleanNaziv = (formData.naziv || "NAZIV TURNIRA")
                      .replace(/\b(20\d{2})\b/g, "")
                      .trim();
                    const slug = formData.slug || "turnir";
                    const kotizacija = formData.kotizacija
                      ? `Kotizacija: ${formData.kotizacija} €`
                      : "";
                    const formatIgraca = formData.broj_igraca
                      ? `Igrači: ${formData.broj_igraca - 1}+1`
                      : "";

                    let text = `🏆 ${cleanNaziv.toUpperCase()} 🏆\n\n`;
                    text += `U suradnji s ${cleanNaziv} možete pratiti raspored, rezultate, grupe i završnicu!\n\n`;

                    if (formData.datum_od && formData.datum_do) {
                      const formatDateStr = (d) => {
                        if (!d) return "";
                        const date = new Date(d);
                        return date.toLocaleDateString("hr-HR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        });
                      };
                      text += `📅 Datum: ${formatDateStr(formData.datum_od)} - ${formatDateStr(formData.datum_do)}\n`;
                    }
                    if (kotizacija || formatIgraca) {
                      text += `⚽ Sustav: ${formatIgraca}${kotizacija ? ` | ${kotizacija}` : ""}\n`;
                    }

                    text += `\n💰 NAGRADNI FOND:\n`;
                    if (formData.total_fund)
                      text += `• Ukupni fond: ${formData.total_fund} €\n`;
                    if (formData.first_place)
                      text += `• 1. mjesto: ${formData.first_place} €\n`;
                    if (formData.second_place)
                      text += `• 2. mjesto: ${formData.second_place} €\n`;
                    if (formData.third_place)
                      text += `• 3. mjesto: ${formData.third_place} €\n`;

                    if (
                      formData.features?.veterani &&
                      (formData.first_place_veterani ||
                        formData.second_place_veterani ||
                        formData.third_place_veterani)
                    ) {
                      text += `\n👴 VETERANI:\n`;
                      if (formData.first_place_veterani)
                        text += `• 1. mjesto: ${formData.first_place_veterani} €\n`;
                      if (formData.second_place_veterani)
                        text += `• 2. mjesto: ${formData.second_place_veterani} €\n`;
                      if (formData.third_place_veterani)
                        text += `• 3. mjesto: ${formData.third_place_veterani} €\n`;
                    }

                    text += `\n🍺 Očekuje vas odlična zabava, hrana i piće!\n\n`;
                    text += `🔗 Link turnira: fucascore.com/${slug}\n\n`;
                    text += `Vidimo se na terenu! ⚽🔥\n\n`;
                    text += `#futsal #turnir #fucascore #nogomet #malinogomet`;

                    return text;
                  })()}
                  style={{
                    width: "100%",
                    height: "120px",
                    background: "rgba(0,0,0,0.3)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: "8px",
                    color: "#fff",
                    padding: "10px",
                    fontSize: "0.8rem",
                    resize: "none",
                    boxSizing: "border-box",
                  }}
                />
                <button
                  type="button"
                  onClick={() => {
                    const textToCopy = (() => {
                      const cleanNaziv = (formData.naziv || "NAZIV TURNIRA")
                        .replace(/\b(20\d{2})\b/g, "")
                        .trim();
                      const slug = formData.slug || "turnir";
                      const kotizacija = formData.kotizacija
                        ? `Kotizacija: ${formData.kotizacija} €`
                        : "";
                      const formatIgraca = formData.broj_igraca
                        ? `Igrači: ${formData.broj_igraca - 1}+1`
                        : "";

                      let text = `🏆 ${cleanNaziv.toUpperCase()} 🏆\n\n`;
                      text += `U suradnji s ${cleanNaziv} možete pratiti raspored, rezultate, grupe i završnicu!\n\n`;

                      if (formData.datum_od && formData.datum_do) {
                        const formatDateStr = (d) => {
                          if (!d) return "";
                          const date = new Date(d);
                          return date.toLocaleDateString("hr-HR", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          });
                        };
                        text += `📅 Datum: ${formatDateStr(formData.datum_od)} - ${formatDateStr(formData.datum_do)}\n`;
                      }
                      if (kotizacija || formatIgraca) {
                        text += `⚽ Sustav: ${formatIgraca}${kotizacija ? ` | ${kotizacija}` : ""}\n`;
                      }

                      text += `\n💰 NAGRADNI FOND:\n`;
                      if (formData.total_fund)
                        text += `• Ukupni fond: ${formData.total_fund} €\n`;
                      if (formData.first_place)
                        text += `• 1. mjesto: ${formData.first_place} €\n`;
                      if (formData.second_place)
                        text += `• 2. mjesto: ${formData.second_place} €\n`;
                      if (formData.third_place)
                        text += `• 3. mjesto: ${formData.third_place} €\n`;

                      if (
                        formData.features?.veterani &&
                        (formData.first_place_veterani ||
                          formData.second_place_veterani ||
                          formData.third_place_veterani)
                      ) {
                        text += `\n👴 VETERANI:\n`;
                        if (formData.first_place_veterani)
                          text += `• 1. mjesto: ${formData.first_place_veterani} €\n`;
                        if (formData.second_place_veterani)
                          text += `• 2. mjesto: ${formData.second_place_veterani} €\n`;
                        if (formData.third_place_veterani)
                          text += `• 3. mjesto: ${formData.third_place_veterani} €\n`;
                      }

                      text += `\n🍺 Očekuje vas odlična zabava, hrana i piće!\n\n`;
                      text += `🔗 Link turnira: fucascore.com/${slug}\n\n`;
                      text += `Vidimo se na terenu! ⚽🔥\n\n`;
                      text += `#futsal #turnir #fucascore #nogomet #malinogomet`;

                      return text;
                    })();

                    navigator.clipboard.writeText(textToCopy);
                    alert("Tekst za Instagram je kopiran u međuspremnik!");
                  }}
                  style={{
                    marginTop: "8px",
                    width: "100%",
                    background: "#00e676",
                    color: "#001509",
                    border: "none",
                    padding: "10px",
                    borderRadius: "20px",
                    fontWeight: "700",
                    cursor: "pointer",
                  }}
                >
                  Kopiraj tekst za Instagram
                </button>
              </div>
              <div className="modal-actions">
                <button
                  className="save"
                  onClick={handleSave}
                  disabled={isUploading}
                >
                  {isUploading ? "Spremanje..." : "Spremi"}
                </button>
                <button
                  className="cancel"
                  onClick={() => setIsModalOpen(false)}
                >
                  Odustani
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FSAdminAddTurnir;
